import CostUnitPaymentTypeEnum from '@js/enums/damage/CostUnitPaymentTypeEnum';
import Container from '@services/Container';

const container = Container.getInstance();
const recordRepository = container.getDesktopRecordRepository();

export default {
    data() {
        return {
            lastPaymentTypeId: [],
        }
    },
    methods: {
        loadPaymentTypeOptions(subformIdentifier) {
            const insuranceFigure = this.formContext.form.getProperty('insuranceFigure');
            /**
             * @see NC24_Model_Factory_Dropdown::getVehicleDamageRecordCostUnitPaymentTypesOptions()
             */
            return recordRepository.loadLegacySelectOptions(
                'vehicleDamageRecordCostUnitPaymentTypes',
                {
                    isNet: insuranceFigure === 'net',
                    canUseCopaymentTypes: this.formContext.form.getSubform(subformIdentifier)
                        .getProperty('canHaveCopaymentPayments'),
                    hasExternalPayment: this.formContext.form.getSubform(subformIdentifier)
                        .getProperty('hasExternalPayment'),
                    currentPaymentTypeId: this.formContext.form.getSubform(subformIdentifier)
                        .getProperty('paymentType'),
                }
            );
        },

        handlePaymentTypeChange(subformIdentifier) {
            const paymentType = this.paymentType(subformIdentifier);

            if (!this.formContext.form.getSubform(subformIdentifier).getProperty('isEntityNew')) {
                return; // no change if payment is not in new creation
            }

            // we pass subformIdentifier to the amountOpen... methods - in some cases this argument will not be used
            switch (paymentType) {
                case CostUnitPaymentTypeEnum.FINALPAYMENT:
                    this.formContext.form.getSubform(subformIdentifier).setProperty(
                        'amount',
                        this.amountOpenInsurance(subformIdentifier)
                    );
                    break;
                case CostUnitPaymentTypeEnum.COPAYMENT_COMPENSATION:
                case CostUnitPaymentTypeEnum.COPAYMENT_COMPENSATION_CAR_DEALER:
                    this.formContext.form.getSubform(subformIdentifier).setProperty(
                        'amount',
                        this.amountOpenCopayment(subformIdentifier)
                    );
                    break;
                case CostUnitPaymentTypeEnum.VAT_COMPENSATION:
                    this.formContext.form.getSubform(subformIdentifier).setProperty(
                        'amount',
                        this.amountOpenVat(subformIdentifier)
                    );
                    break;
                default: {
                    const lastPaymentType = this.lastPaymentType(subformIdentifier);
                    const presetPaymentTypes = [
                        CostUnitPaymentTypeEnum.FINALPAYMENT,
                        CostUnitPaymentTypeEnum.COPAYMENT_COMPENSATION,
                        CostUnitPaymentTypeEnum.COPAYMENT_COMPENSATION_CAR_DEALER,
                        CostUnitPaymentTypeEnum.VAT_COMPENSATION,
                    ];

                    if (presetPaymentTypes.includes(lastPaymentType)) {
                        // reset amount to 0 if value was set by a preset payment type
                        this.formContext.form.getSubform(subformIdentifier).setProperty('amount', 0);
                    }
                }
            }

            // set new type as last type for next change
            this.lastPaymentTypeId[subformIdentifier] = paymentType;
        },
        paymentType(subformIdentifier) {
            return this.formContext.form.getSubform(subformIdentifier).getProperty('paymentType');
        },
        lastPaymentType(subformIdentifier) {
            return this.lastPaymentTypeId[subformIdentifier] || null;
        },
    },
}
